// src/constants/permission-menu.js
import { basePermissionMenu } from  '@/constants/permission-menu'
// 获取权限码列表
export const getAuthCodes = () => {
  // 这里替换为实际获取权限码的逻辑
  return JSON.parse(localStorage.getItem('AUTH_CODES') || '[]')
}

const getPlatformType = function () {
  let accountDto = localStorage.getItem('ACCOUNT_DTO')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
    return accountDto.platformType
  }
  return 0
}

export const getAccountId = function () {
  let accountDto = localStorage.getItem('ACCOUNT_DTO')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
    return accountDto.id
  }
  return ''
}

export const getParentAccountId = function () {
  let accountDto = localStorage.getItem('ACCOUNT')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
    return accountDto.parentId
  }
  return ''
}

/**
 * 根据id查找菜单节点
 * @param {string} id - 要查找的节点id
 * @param {Array} menuList - 要搜索的菜单数组，默认搜索basePermissionMenu
 * @returns {Object|null} 返回找到的节点对象，如果未找到返回null
 */
export const findMenuNodeById = (id, menuList) => {
  for (const item of menuList) {
    if (item.id === id) {
      return item;
    }
    
    if (item.children) {
      const found = findMenuNodeById(id, item.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

/**
 * 判断节点或其子节点的id是否在指定数组中
 * @param {Object} node - 当前树节点
 * @returns {boolean} - 返回是否应该显示该节点
 */
export const isNodeVisible = (node) => {
  const platformType = getPlatformType()
  // 如果不是客户账号，菜单直接显示（渠道账号或者admin账号）
  if (platformType !== 0) {
    return true
  }
  // 找到权限树对应的节点
  let findNode = findMenuNodeById(node.id, basePermissionMenu)
  
  if (findNode) {
    const ids = getAuthCodes()
    // 判断当前节点
    if (ids.includes(findNode.id)) {
      return true
    }
    
    // 判断子节点
    if (findNode.children && findNode.children.length) {
      return findNode.children.some(child => isNodeVisible(child, ids))
    }
    
  }
  return false
}

export default {
  install(Vue) {
    Vue.directive('per', {
      inserted(el, binding) {
        const { value } = binding
        const authCodes = getAuthCodes()

        if (!value || (value.length && !authCodes.includes(value[0]))) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    })
  }
} 